// graphql-response.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class GraphQLResponseInterceptor implements HttpInterceptor {

  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const body = event.body;
          
          if (body && body.errors && Array.isArray(body.errors)) {
            console.log('GraphQL response contains errors:', body.errors);
            
            const hasForbiddenError = body.errors.some((err: any) => 
              err.extensions && (err.extensions.code === 'FORBIDDEN')
            );
                        
            if (hasForbiddenError) {
              console.log('Detected forbidden access, navigating to forbidden page');
              this.router.navigate(['/forbidden']);
            }
          }
        }
      })
    );
  }
}